import { render, staticRenderFns } from "./PartialPaymentBannerForProductCard.vue?vue&type=template&id=f6bf9dba&lang=pug&"
import script from "./PartialPaymentBannerForProductCard.vue?vue&type=script&lang=ts&"
export * from "./PartialPaymentBannerForProductCard.vue?vue&type=script&lang=ts&"
import style0 from "./PartialPaymentBannerForProductCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports